import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import User from "../../stores/UserStore";
import { Details } from "@mui/icons-material";
import General from "../../stores/GeneralStore";

type ModalProps = {
  setValue : any;
  onClose?: () => void;
};

const ValidationModal: FC<ModalProps> = ({ setValue, onClose }) => {
  const navigate = useNavigate();
  const [details, setDetails] = useState<any>(null);
  
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await User.getProfile(User.info.personId);
        console.log("user details", res);
        setDetails(res);
      } catch (err) {
        console.error("Failed to load profile", err);
      }
    };

    fetchProfile();
  }, []);

return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.4)", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999999,
      }}
    >
    <div style={{
      position: "relative",
      width: "90%",
      maxWidth: "500px",
      minWidth: "320px",
      minHeight: "220px",
      left: General?.isLargeScreen ? "" : "22px",
    }}>
      <div
          style={{
            background: "#101E8E",
            color: "#fff",
            padding: "12px 16px",
            fontSize: "18px",
            fontWeight: 600,
            width: "90%",
            maxWidth: "500px",
            minWidth: "320px",
            textAlign: "center",
            boxSizing: "border-box",
          }}
        >
          {General?.codeLabels["cm_update_your_profile"]
                            ?.label}
        </div>
      <div
        style={{
          background: "#fffffff6",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.25)",
          minHeight: "220px",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "90%",
          maxWidth: "500px",
          minWidth: "320px"
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontSize: "18px",
            color: "#333",
            marginBottom: "24px",
          }}
        >
        {!details ? (
          General?.codeLabels["cm_profile_checking_details"]?.label ?? "Checking your profile details..."
        ) : (
          <>
            {(!details?.result?.email || details?.result?.email == "NA") && (!details?.result?.mobileNumber || details?.result?.mobileNumber == "NA") && (
              <>
                {General?.codeLabels["cm_profile_invalid_contact"]?.label ?? "You don’t have a valid email and mobile number. Please update your profile to continue.."}
              </>
            )}
            {(!details?.result?.email || details?.result?.email == "NA") && details?.result?.mobileNumber && (
              <>
                {General?.codeLabels["cm_invalid_email"]?.label ?? "You don’t have a valid email. Please update your profile to continue.."}
              </>
            )}
            {details?.result?.email && (!details?.result?.mobileNumber || details?.result?.mobileNumber == "NA") && (
              <>
                {General?.codeLabels["cm_invalid_mobile_number"]?.label ?? "You don’t have a valid mobile number. Please update your profile to continue.."}
              </>
            )}
          </>
        )}
        </p>

        <button
          style={{
            background: "#101E8E",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            fontSize: "1rem",
            fontWeight: 600,
            boxShadow: "0 2px 8px rgba(16, 30, 142, 0.2)",
            cursor: "pointer",
          }}
          onClick={() => {
            setValue(6);
            if (onClose) onClose(); 
          }}
        >
          {General?.codeLabels["cm_go_to_profile"]?.label ?? "Go to Profile"}
        </button>
      </div>
      </div>
     
    </div>
  );
};

export default observer(ValidationModal);
